import * as actionTypes from '../actions/actionTypes';

const initialState = {
    TeamData: [],
    TeamDetailsData: [],
    TeamMembers: {},
    CoManagerData: [],
    PlayerData:[],
    PaymentRecords: [],
    PendingPaymentRecords: [],
    // VenuData: false
    YourTeamData: [],
    isLoading: false,
    PendingInvitations: [],  // <-- ADD THIS
};

const TeamReducer = (state = initialState, action) => {

        //console.log("⚡ Action received:", action.type);
    if (action.type === "GET_PENDING_INVITATIONS_SUCCESS") {
        //console.log("⚡ STRING MATCH FOUND!");
    }

    switch (action.type) {


        
        case actionTypes.SET_LOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        case actionTypes.ADD_TEAMS:
            return {
                ...state,

            };

        case actionTypes.GET_TEAMS:
            return {
                ...state,
                TeamData: action.payload || [],
            };
        case actionTypes.GET_TEAM_BY_ID:
            return {
                ...state,
                TeamDetailsData: action.payload || []
            }
        case actionTypes.GET_CO_MANAGERS:
            return {
                ...state,
                CoManagerData: action.payload || []
            }
            case actionTypes.GET_PLAYERS:
                return {
                    ...state,
                    PlayerData: action.payload || []
                }
        case actionTypes.GET_MEMBER_BY_TEAMID:
            return {
                ...state,
                TeamMembers: action.payload || {}
            }
        case actionTypes.GET_YOUR_TEAM:
            return {
                ...state,
                YourTeamData: action.payload || []
            }

        case actionTypes.GET_PAYMENT_RECORDS:
            return {
                ...state,
                PaymentRecords: action.payload || []
            }
        case actionTypes.GET_PENDING_PAYMENT_RECORDS:
            return {
                ...state,
                PendingPaymentRecords: action.payload || []
            }

        case actionTypes.GET_PENDING_INVITATIONS_REQUEST:  // ✅ FIXED INDENTATION
            return {
                ...state,
                isLoading: true,
            };

        case actionTypes.GET_PENDING_INVITATIONS_SUCCESS:  // ✅ FIXED INDENTATION
            //console.log("📥 Reducer: GET_PENDING_INVITATIONS_SUCCESS");
            //console.log("📥 Payload received in reducer:", action.payload);
            return {
                ...state,
                PendingInvitations: action.payload,
                isLoading: false,
            };

        case actionTypes.GET_PENDING_INVITATIONS_FAILURE:  // ✅ FIXED INDENTATION
            return {
                ...state,
                PendingInvitations: [],
                isLoading: false,
            };

        case actionTypes.CLEAR_TEAM:
            return {
                TeamData: [],
                TeamDetailsData: [],
                TeamMembers: {},
                CoManagerData: [],
                PaymentRecords: [],
                PendingPaymentRecords: [],
                // VenuData: false
                YourTeamData: [],
                isLoading: false,
                PendingInvitations: [],  // Add this too
            }





        default:
            return state;



    }
}

export default TeamReducer;
